interface Environment {
  production: boolean;
  url: string;
  wsUrl: string;
  enableRoutingTracing: boolean;
  enableRegistration: boolean;
  enableEditor: boolean;
  posthogEnabled: boolean;
  posthogKey: string;
  posthogHost: string;
  auth: {
    domain: string;
    clientId: string;
    authorizationParams: {
      audience: string;
    };
    httpInterceptor: {
      allowedList: string[];
    };
  };
}

export const environment: { [key: string]: Environment } = {
  local: {
    production: false,
    url: '/api/',
    wsUrl: 'ws://localhost:3000/ws',
    enableRoutingTracing: true,
    enableRegistration: true,
    enableEditor: true,
    posthogEnabled: false,
    posthogKey: '',
    posthogHost: '',
    auth: {
      domain: 'auth.aimestech.com',
      clientId: '9nmY5UPYEqJEMDGeb0FdWloEIjWBAt70', // Using demo clientId for local development
      authorizationParams: {
        audience: 'demo.aimestech.com',
      },
      httpInterceptor: {
        allowedList: ['/api/*', 'http://localhost:8080/api/*'],
      },
    },
  },
  demo: {
    production: true,
    url: 'https://demo.aimestech.com/api',
    wsUrl: 'wss://demo.aimestech.com/ws',
    enableRoutingTracing: false,
    enableRegistration: true,
    enableEditor: false,
    posthogEnabled: false,
    posthogKey: '',
    posthogHost: '',
    auth: {
      domain: 'auth.aimestech.com',
      clientId: '9nmY5UPYEqJEMDGeb0FdWloEIjWBAt70',
      authorizationParams: {
        audience: 'demo.aimestech.com',
      },
      httpInterceptor: {
        allowedList: ['https://demo.aimestech.com/api/*'],
      },
    },
  },
  solution: {
    production: true,
    url: 'https://solution.aimestech.com/api',
    wsUrl: 'wss://solution.aimestech.com/ws',
    enableRoutingTracing: false,
    enableRegistration: true,
    enableEditor: false,
    posthogEnabled: true,
    posthogKey: 'phc_sfQrIhNVNT7FGFFIGBpg0QTAb9cCFBjOzTQUvJH8uWn',
    posthogHost: 'https://eu.i.posthog.com',
    auth: {
      domain: 'auth.aimestech.com',
      clientId: 'hjthTK9fxAmWNXHYtTWmQiEBsFAsvvLu',
      authorizationParams: {
        audience: 'solution.aimestech.com',
      },
      httpInterceptor: {
        allowedList: ['https://solution.aimestech.com/api/*'],
      },
    },
  },
  pif: {
    production: true,
    url: 'https://pif.aimestech.com/api',
    wsUrl: 'wss://pif.aimestech.com/ws',
    enableRoutingTracing: false,
    enableRegistration: false,
    enableEditor: false,
    posthogEnabled: false,
    posthogKey: '',
    posthogHost: '',
    auth: {
      domain: 'auth.aimestech.com',
      clientId: '9nmY5UPYEqJEMDGeb0FdWloEIjWBAt70',
      authorizationParams: {
        audience: 'demo.aimestech.com',
      },
      httpInterceptor: {
        allowedList: ['https://pif.aimestech.com/api/*'],
      },
    },
  },
};
